import { useContext, useEffect, useState } from "react";
import Input from "../../../../components/Inputs/Input";
import coloredWarningImage from "../../../../assets/Icons/colored-warning.svg";
import { createPart } from "../../services/PartsConfigurationService";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import CheckboxField from "../../../../components/Checkbox/CheckboxField";
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { DropdownsContext } from "../../../../contexts/DropdownsContext";
import { usePermissions } from "../../../../hooks/usePermissions";
import {
  localStorageGet,
  localStorageSave,
} from "../../../../services/localStorageService";
import {
  createType,
  getAircraftConfigurationInfo,
  getTypeSeriesConfigurationInfo,
  updateAircraft,
} from "../../services/AircraftConfigurationService";

import BasicDatePicker from "../../../../components/Datepicker/Datepicker";
import { AircraftConfigurationContext } from "../../contexts/AircraftConfigurationContext";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { use } from "react";

// const dropdownIds = [4, 5, 6, 7];
const dropdownNames = {
  33: "operationalStatus",
  34: "ownerId",
  35: "leaseTypeId",
  36: "selcal",
  61: "companyId",
};

const defaultEmptyValues = {
  tailNumber: "",
  registrationNumber: "",
  serialNumber: "",
  lineNumber: "",
  operationalStatus: null,
  inServiceDate: null,
  ownerId: null,
  leaseTypeId: null,
  endLeaseDate: null,
  catRatingId: null,
  etops: "",
  sgmlReferenceNumber: "",
  maintenanceManualRef: "",
  variableEngineeringNumber: "",
  ipcReferenceNumber: "",
  selcal: null,
  companyId: null,
  modeS: "",
  manuFacturerDate: null,
};
const hideFieldsWhenDisabled = new Set([
  "Status",
  "Owner",
  "Lease Type",
  "Selcal",
  "CAT Rating",
]);
const localStoragePrefix = "configuration/aircraft/generalInfo/draft/general";
const ribbonColors = ["var(--blue-300)", "var(--green-350)", "#f7931e"];
const AircraftForm = ({ aircraft, disabled, ribbon, open }) => {
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  const { updateValue } = useContext(AircraftConfigurationContext);
  const [values, setValues] = useState({ ...defaultEmptyValues });
  const [backup, setBackup] = useState(null);
  const [defaults, setDefaults] = useState({});
  const { hasPermission } = usePermissions();
  const [partBackup, setPartBackup] = useState(null);
  const [dataCompanyDrop, setDataCompanyDrop] = useState([]);
  const [errorState, setErrorState] = useState({});
  // const [defaults, setDefaults] = useState(null);
  const requiredFields = {
    tailNumber: true,
    registrationNumber: true,
    serialNumber: true,
    lineNumber: true,
  };
  const {
    saveDraft,
    removeDraft,
    resetType,
    confirmType,
    newDrafts,
    isAircraftSectionDraft,
    updateSection,
  } = useContext(AircraftConfigurationContext);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const cancelEdit = () => {
    removeDraft(aircraft.id, "general");
    setValues(backup ?? defaultEmptyValues);
    setDefaults(backup ?? defaultEmptyValues);
    resetType(aircraft.id);
  };


  useEffect(() => {
    setDataCompanyDrop(() => JSON.parse(localStorage.getItem("u_companies")));
    if (open) {
      getAircraftConfigurationInfo(aircraft.id)
        .then((response) => {
          if (response.data.responseCode === 200) {
            if (response.data.load != null) {
              let {
                id,
                tailNumber,
                registrationNumber,
                serialNumber,
                lineNumber,
                operationalStatus,
                inServiceDate,
                ownerId,
                leaseTypeId,
                endLeaseDate,
                catRatingId,
                etops,
                sgmlReferenceNumber,
                maintenanceManualRef,
                variableEngineeringNumber,
                ipcReferenceNumber,
                selcal,
                modeS,
                typeSeries,
                manuFacturerDate,
                version,
                companyId,
              } = response.data.load;
              setPartBackup(response.data.load);
              let draftValues = localStorageGet(localStoragePrefix, {
                id: aircraft.id.toString(),
              })[0];
              let form = {
                ...defaultEmptyValues,
                id,
                tailNumber: tailNumber,
                registrationNumber: registrationNumber,
                serialNumber: serialNumber,
                lineNumber: lineNumber,
                operationalStatus: operationalStatus,
                inServiceDate: inServiceDate,
                ownerId: ownerId,
                leaseTypeId: leaseTypeId,
                endLeaseDate: endLeaseDate,
                catRatingId: catRatingId,
                etops: etops,
                sgmlReferenceNumber: sgmlReferenceNumber,
                maintenanceManualRef: maintenanceManualRef,
                variableEngineeringNumber: variableEngineeringNumber,
                ipcReferenceNumber: ipcReferenceNumber,
                selcal: selcal,
                modeS: modeS,
                manuFacturerDate: manuFacturerDate,
                version: version,
                companyId: companyId,
                typeSeries: { id: typeSeries.id },
              };
              setDefaults({ ...form, ...draftValues });
              setValues({ ...form, ...draftValues });
              setBackup(form);
            }
          }
        })
        .catch((error) => {
          console.error(error);
          let form = { ...defaultEmptyValues };
          setDefaults(form);
          setValues(form);
        });
    }
  }, [open, aircraft]);

  const handleDropdownValue = (value, name, data) => {
    changeValue({ target: { name, value: value[data], completeValue: value } });

    setDefaults((prev) => ({
      ...prev,
      ...{ [name]: " " },
    }));
  };

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  useEffect(() => {
    if (disabled && typeof values.id === "number") {
      localStorageSave(localStoragePrefix, { id: aircraft.id }, values);
    }
  }, [values]);
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const generalSectionButtons = [
    {
      label: "Save and Finish",
      onClick: () => saveSection(true),
      icon: "icon-save",
      id: "save",
    },
    {
      label: "Save and Continue Editing",
      onClick: () => saveSection(false),
      icon: "icon-save",
      id: "save-continue",
    },
    {
      label: "Cancel",
      onClick: () => cancelEdit(),
      icon: "icon-cross",
      id: "cancel",
      type: "danger",
    },
  ];
  const updateValues = (formValue) => {
    updateSection(formValue, aircraft.id, "general");
    // let { name, value } = formValue;
    // updateRow(part.id, rowUpdater[name]?.(value) ?? { [name]: value });
  };
  const changeValueDate = (newValue, name) => {
    const completeValue = newValue?.format("MM-DD-YYYY");
    updateValue(aircraft.id, name, completeValue);
    setValues((prev) => {
      updateValues?.(
        { name, value: completeValue ?? newValue },
        { ...prev, [name]: newValue }
      );
      return {
        ...prev,
        ...{ [name]: newValue },
      };
    });
  };
  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    if (name in requiredFields) {
      setErrorState((prev) => ({
        ...prev,
        [name]: value || completeValue ? "" : "Required",
      }));
    }
    updateValue(aircraft.id, name, completeValue);
    setValues((prev) => {
      updateValues?.(
        { name, value: completeValue ?? value },
        { ...prev, [name]: value }
      );
      return {
        ...prev,
        ...{ [name]: value },
      };
    });
  };

  const saveSection = (disableForm) => {
    infoMsg("Saving...");

    // let draft = JSON.parse(localStorage.getItem(`${localStoragePrefix}?id=${part.id}`) ?? "{}");
    let draft = localStorageGet(localStoragePrefix, {
      id: aircraft.id.toString(),
    })[0];

    draft.series = { id: draft.series };
    let errors = {};
    for (let k in requiredFields) {
      if (!draft[k]) {
        errors[k] = "Required";
      }
    }
    setErrorState(errors);

    updateAircraft(draft)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
          successMsg("Aircraft saved successfully");
          setValues({ ...defaultEmptyValues, ...response.data.load });
          setBackup({ ...defaultEmptyValues, ...response.data.load });
          confirmType(aircraft.id);
          if (disableForm) {
            removeDraft(aircraft.id, "general");
          }
        } else if (
          response.data.responseCode === HTTP_RESPONSE_CODES.VALIDATIONS_FAILED
        ) {
          warningMsg(
            response.data.message ||
              `Something went wrong: ${response.data.responseCode}`,
            "One or more fields are invalid.",
            30000
          );
        } else {
          warningMsg(
            response.data.message ||
              `Something went wrong: ${response.data.responseCode}`,
            100000
          );
        }
      })
      .catch((error) => warningMsg(`Something went wrong: ${error}`));
  };

  return (
    <div className="general-aircraft-section-form-wrapper">
      <div className="general-section-aircraft-form-component">
        <div className="general-section-aircraft-form-header">
          {ribbon && (
            <div className="ribbons-container">
              {ribbon
                .filter?.((r) => r.when)
                ?.map?.((r, i, a) => (
                  <span
                    className="ribbon"
                    key={r.label}
                    style={{
                      backgroundColor:
                        r.color ?? ribbonColors[i % ribbonColors.length],
                      left:
                        i < a.length - 1
                          ? `${-0.5 * (ribbon.length - 1 - i)}rem`
                          : "",
                    }}
                  >
                    {r.label}
                  </span>
                ))}
            </div>
          )}
          <div className="title-container">
            <b>General Information</b>
          </div>
          <div className="general-info-actions">
            {!disabled && hasPermission("update") && (
              <button
                className="outlined iconTextButton small-size"
                onClick={() => saveDraft(aircraft.id, "general", values)}
              >
                <i className="icon-edit"></i>
                <span>Edit</span>
              </button>
            )}
            {disabled && hasPermission("update") && (
              <MultioptionButton buttons={generalSectionButtons} />
            )}
          </div>
        </div>
        <div className="general-aircraft-form">
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            onChange={changeValue}
            name="tailNumber"
            error={errorState["tailNumber"]}
            required={true}
            disableAutocomplete={true}
            label={"Tail Number"}
            value={values["tailNumber"]}
          />
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            onChange={changeValue}
            error={errorState["registrationNumber"]}
            required={true}
            name="registrationNumber"
            disableAutocomplete={true}
            label={"Registration Number"}
            value={values["registrationNumber"]}
          />
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            onChange={changeValue}
            name="serialNumber"
            error={errorState["serialNumber"]}
            required={true}
            disableAutocomplete={true}
            label={"AC Serial Number"}
            format={false}
            isNumeric={true}
            value={values["serialNumber"]}
          />
        </div>
        <div className="general-aircraft-form-three">
          {dataCompanyDrop?.length > 0 && <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[61])}
            disabled={!disabled}
            required={true}
            key={61}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[61], data)
            }
            isStatic={true}
            staticData={dataCompanyDrop}
            staticDataColumnPreselection={"id"}
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 61)}
            preSelectValue={defaults?.[dropdownNames[61]]}
          />}
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            onChange={changeValue}
            disableAutocomplete={true}
            name="lineNumber"
            isNumeric={true}
            error={errorState["lineNumber"]}
            format={false}
            required={true}
            label={"Line Number"}
            value={values["lineNumber"]}
          />

          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[33])}
            disabled={!disabled}
            required={true}
            key={33}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[33], data)
            }
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 33)}
            preSelectValue={defaults?.[dropdownNames[33]]}
            parentComponentId={aircraft.id}
          />
        </div>
        <div className="general-aircraft-form">
          <BasicDatePicker
            style={{ gridColumn: "span 1" }}
            label={"In Service Date"}
            value={values["inServiceDate"]}
            onChange={(newValue) => {
              changeValueDate(newValue, "inServiceDate");
            }}
            disabled={!disabled}
            isDateTime={false}
          ></BasicDatePicker>
          <Dropdowns
            display2Grid={true}
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[34])}
            disabled={!disabled}
            key={34}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[34], data)
            }
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 34)}
            preSelectValue={defaults?.[dropdownNames[34]]}
            parentComponentId={aircraft.id}
          />
        </div>
        <div className="general-aircraft-form-two">
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[35])}
            disabled={!disabled}
            key={35}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[35], data)
            }
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 35)}
            preSelectValue={defaults?.[dropdownNames[35]]}
            parentComponentId={aircraft.id}
          />
          <div className="general-aircraft-form-row">
            <BasicDatePicker
              style={{ width: "70%" }}
              label={"End of Lease Date"}
              disabled={!disabled}
              isDateTime={false}
              value={values["endLeaseDate"]}
              name="endLeaseDate"
              onChange={(newValue) => {
                changeValueDate(newValue, "endLeaseDate");
              }}
            ></BasicDatePicker>

            <Input
              style={{ width: "50%" }}
              disabled={!disabled}
              name="catRatingId"
              disableAutocomplete={true}
              onChange={changeValue}
              label={"CAT Rating"}
              isNumeric={true}
              value={values["catRatingId"]}
            />
          </div>
        </div>
        <div className="general-info-etops">
          <p>ETOPS</p>
          <div className="general-info-etops-container">
            {/* <p>DOWNGRADED</p> */}
            <div className="general-info-etops-container-info">
              <Input
                style={{ gridColumn: "span 1" }}
                onChange={changeValue}
                disabled={!disabled}
                name="etops"
                label={""}
                isNumeric={true}
                disableAutocomplete={true}
                value={values["etops"]}
              />
              <Input
                style={{ gridColumn: "span 1" }}
                disabled={true}
                onChange={changeValue}
                name="minutes"
                label={"Minutes"}
                disableAutocomplete={true}
                value={values["minutes"]}
              />
            </div>
          </div>
        </div>
        <div className="general-aircraft-form-two">
          <Input
            style={{ gridColumn: "span 1" }}
            onChange={changeValue}
            disabled={!disabled}
            disableAutocomplete={true}
            name="variableEngineeringNumber"
            label={"Variable Engineering Number"}
            value={values["variableEngineeringNumber"]}
          />
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            onChange={changeValue}
            disableAutocomplete={true}
            name="ipcReferenceNumber"
            label={"IPC Reference Number"}
            value={values["ipcReferenceNumber"]}
          />
        </div>
        <div className="general-aircraft-form-two">
          <Input
            style={{ gridColumn: "span 1" }}
            onChange={changeValue}
            disabled={!disabled}
            disableAutocomplete={true}
            name="maintenanceManualRef"
            label={"Maintenance Manual Reference Number"}
            value={values["maintenanceManualRef"]}
          />
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            onChange={changeValue}
            disableAutocomplete={true}
            name="sgmlReferenceNumber"
            label={"SGML Reference Number"}
            value={values["sgmlReferenceNumber"]}
          />
        </div>
        <div className="general-aircraft-form">
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            hideWhenDisabled={hideFieldsWhenDisabled.has(dropdownNames[36])}
            disabled={!disabled}
            key={36}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[36], data)
            }
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 36)}
            preSelectValue={defaults?.[dropdownNames[36]]}
            parentComponentId={aircraft.id}
          />
          <Input
            style={{ gridColumn: "span 1" }}
            disabled={!disabled}
            name="modeS"
            onChange={changeValue}
            label={"Mode S"}
            disableAutocomplete={true}
            value={values["modeS"]}
          />
          <BasicDatePicker
            style={{ gridColumn: "span 1" }}
            label={"Manufacturer Date"}
            value={values["manuFacturerDate"]}
            onChange={(newValue) => {
              changeValueDate(newValue, "manuFacturerDate");
            }}
            disabled={!disabled}
            isDateTime={false}
            name="manuFacturerDate"
          ></BasicDatePicker>
        </div>
      </div>
    </div>
  );
};

export default AircraftForm;
